import type { RootState } from '@shared/stores/rootTypes';
// Create New Appointment

const newAppointmentSelector = (state: RootState) => state.appointment.createNewAppointment;

const vcpPatientDetailsSelector = (state: RootState) => state.appointment.vcpPatientDetails;
// Reschedule and Book Next Appointment

const selectedNewRescheduleAppointment = (state: RootState) =>
  state.appointment.rescheduleAndBookNext.appointmentSubmit;

const selectedAppointmentSelector = (state: RootState) => state.appointment.selectedAppointment;

const selectedLinkedAppointmentSelector = (state: RootState) =>
  state.appointment.rescheduleAndBookNext.selectedLinkedAppointment;

const linkedAppointmentMapSelector = (state: RootState) =>
  state.appointment.rescheduleAndBookNext.linkedAppointmentSlotMap;

const selectedSlotSelector = (state: RootState) => state.appointment.selectedSlot;

const selectedFinalConfirmMessageSelector = (state: RootState) => state.appointment.finalConfirmMessage;

const answerQuestionnaireValueSelector = (state: RootState) =>
  state.appointment.preQuestionnaire.answerQuestionnaireValue;

const currentQuestionIndexSelector = (state: RootState) => state.appointment.preQuestionnaire.currentQuestionIndex;

const currentNumberOfAddButtonSelector = (state: RootState) =>
  state.appointment.preQuestionnaire.currentNumberOfAddButton;

const isShowButtonBackToSummarySelector = (state: RootState) =>
  state.appointment.preQuestionnaire.isShowButtonBackToSummary;

const isHideQueueReminderSelector = (state: RootState) => state.appointment.isHideQueueReminder;

const isTrafficLightFlowSelector = (state: RootState) => state.appointment.isTrafficLightFlow;

const selectedTodayAppointmentSelector = (state: RootState) => state.appointment.mregTodayAppointment;

const appointmentTypeSelector = (state: RootState) => state.appointment.appointmentType;

const selectedAppointmentSystemParamsSelector = (state: RootState) => state.appointment.systemParams;

const mregSuccessErrTextSelector = (state: RootState) => state.appointment.mregSuccessErrText;

const mregContactNoUpdatedQnosSelector = (state: RootState) => state.appointment.mregContactNoUpdatedQnos;

const appointmentDateRangeSelector = (state: RootState) => state.appointment.appointmentDateRange;

const hsgAppointmentTcuRequestId = (state: RootState) => state.appointment.hsgTcuRequestId;

const kkTelePaedsFormValuesSelector = (state: RootState) => state.appointment.kkTelePaedsFormValues;

const kkTelePaedsRequestorDetailsSelector = (state: RootState) => state.appointment.kkTelePaedsRequestorDetails;

export {
  answerQuestionnaireValueSelector,
  appointmentDateRangeSelector,
  appointmentTypeSelector,
  currentNumberOfAddButtonSelector,
  currentQuestionIndexSelector,
  hsgAppointmentTcuRequestId,
  isHideQueueReminderSelector,
  isShowButtonBackToSummarySelector,
  isTrafficLightFlowSelector,
  kkTelePaedsFormValuesSelector,
  kkTelePaedsRequestorDetailsSelector,
  linkedAppointmentMapSelector,
  mregContactNoUpdatedQnosSelector,
  mregSuccessErrTextSelector,
  // create new TCU appointment
  newAppointmentSelector,
  // pre questionnaire
  selectedAppointmentSelector,
  selectedAppointmentSystemParamsSelector,
  selectedFinalConfirmMessageSelector,
  // reschedule bau linked appt
  selectedLinkedAppointmentSelector,
  selectedNewRescheduleAppointment,
  selectedSlotSelector,
  selectedTodayAppointmentSelector,
  vcpPatientDetailsSelector,
};
